export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6255.e4d56199.jpg";